var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('console-content', {
    attrs: {
      "max-width": "1024"
    }
  }, [_c('v-row', {
    staticClass: "mt-4 px-1",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "tit tit--lg",
    attrs: {
      "cols": "auto"
    }
  }, [_vm.$route.params._ip ? _c('span', [_vm._v("IP 상세")]) : _c('span', [_vm._v("IP 생성")])]), _c('v-spacer')], 1), _c('v-card', {
    staticClass: "mx-1 mt-3"
  }, [_c('v-card-title', {
    staticClass: "tit tit--xs"
  }, [_vm._v("IP정보")]), _c('v-card-text', [_c('v-row', [_c('v-col', [_c('v-text-field', {
    attrs: {
      "label": "이름",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.blackIp.name,
      callback: function callback($$v) {
        _vm.$set(_vm.blackIp, "name", $$v);
      },
      expression: "blackIp.name"
    }
  })], 1), _c('v-col', [_c('v-text-field', {
    attrs: {
      "label": "IPv4 address",
      "placeholder": "예) 127.0.0.1",
      "rules": _vm.rules,
      "persistent-placeholder": ""
    },
    model: {
      value: _vm.blackIp.ip,
      callback: function callback($$v) {
        _vm.$set(_vm.blackIp, "ip", $$v);
      },
      expression: "blackIp.ip"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', [_c('v-text-field', {
    attrs: {
      "label": "연락처",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.blackIp.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.blackIp, "phone", $$v);
      },
      expression: "blackIp.phone"
    }
  })], 1), _c('v-col', [_c('v-text-field', {
    attrs: {
      "label": "사유",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.blackIp.reason,
      callback: function callback($$v) {
        _vm.$set(_vm.blackIp, "reason", $$v);
      },
      expression: "blackIp.reason"
    }
  })], 1)], 1)], 1), _c('v-card-actions')], 1), _c('v-card', {
    staticClass: "mt-4 mx-1"
  }, [_c('v-card-title', {
    staticClass: "tit tit--xs font-weight-bold"
  }, [_vm._v("관리자 메모")]), _c('v-card-text', [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "hide-details": "",
      "rows": "2"
    },
    model: {
      value: _vm.blackIp.note,
      callback: function callback($$v) {
        _vm.$set(_vm.blackIp, "note", $$v);
      },
      expression: "blackIp.note"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "my-6"
  }, [_c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")])], 1), _c('v-spacer')], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }